import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  getQrCode: async ({ commit }, payload) => {
    try {
      const { uuid } = payload;

      const res = await axios.get(`/qrcodes/${uuid}`);

      commit('mutateQrCode', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  updateQrCode: async (_, payload) => {
    try {
      // body can be: DOCUMENT, PROFILE, or PROJECT
      const { uuid, ...body } = payload;

      const res = await axios.put(`/qrcodes/${uuid}`, body);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  createQrCode: async (_, payload) => {
    try {
      // entity can be: DOCUMENT, PROFILE, or PROJECT
      const { entity, entityId } = payload;

      const res = await axios.post(`/qrcodes`, '', {
        params: {
          entity,
          entityId
        }
      });

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  },

  getQrCodeImage: async ({ commit }, payload) => {
    try {
      const { uuid } = payload;

      const res = await axios.get(`/qrcodes/show/${uuid}`, {
        responseType: 'arraybuffer'
      });

      commit('mutateQrCodeImage', res.data);

      return res;
    } catch (error) {
      console.error(error);
      return error.response;
    }
  }
};

export const mutations = {
  mutateQrCode: (state, payload) => {
    state.qrCode = payload;
  },

  mutateQrCodeImage: (state, payload) => {
    state.qrCodeImage = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    qrCode: {},
    qrCodeImage: {}
  };
}
